import styled from "styled-components";

export const FavoritePageContainer = styled.div`
  padding-top: 24px;
`;

export const FavoriteContent = styled.div`
  display: flex;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const FavoriteTabContainer = styled.div`
  display: flex;
  margin-bottom: 40px;
  margin-top: 20px;
  border-radius: 8px;
  padding: 2px;
  max-width: 535px;
  min-width: 325px;
  background-color: #ffffff1f;

  @media (min-width: 901px) {
    display: none;
  }
`;

export const FavoriteTabButton = styled.button`
  color: #ffffff;
  background-color: ${({ active }) => (active ? "#F79723" : "transparent")};
  border-radius: 6px;
  padding: 4px;
  text-align: center;
  cursor: pointer;
  border: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  flex: 1;
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (min-width: 901px) {
    display: none;
  }
`;

export const FavoriteListHead = styled.div``;
